import React, { Suspense } from 'react';
import Preloader from '../../preloader';

const withSuspense = (Component) => (props) => <Suspense fallback={<Preloader/>}><Component {...props} /></Suspense>;

export {
  withSuspense,
}
